import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsRoutingModule } from './notifications-routing.module';
import { UserNotificationsComponent } from './pages/user-notifications/user-notifications.component';
import { UserNotificationsDisplayComponent } from './components/user-notifications-display/user-notifications-display.component';
import { StoreModule } from '@ngrx/store';
import * as fromNotifications from './store/reducers/notifications.reducer';
import { EffectsModule } from '@ngrx/effects';
import { NotificationsEffects } from './store/effects/notifications.effects';
import { NotificationsService } from './shared/services/notifications.service';
import { InternalSharedModule } from '../shared';
import { SharedModule } from 'app/shared';


@NgModule({
  declarations: [
    UserNotificationsComponent,
    UserNotificationsDisplayComponent
  ],
  imports: [
    CommonModule,
    InternalSharedModule,
    SharedModule,
    NotificationsRoutingModule,
    StoreModule.forFeature(fromNotifications.notificationsFeatureKey, fromNotifications.reducer),
    EffectsModule.forFeature([NotificationsEffects])
  ],
  providers: [
    NotificationsService
  ]
})
export class NotificationsModule { }
